import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgVenmo = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "1em",
	height: "1em",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "Venmo Icon 2",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M13.3318 1C13.7867 1.84 14 2.70333 14 3.8C14 7.28444 11.2773 11.8189 9.06635 15H4.02607L2 1.77778L6.41469 1.30333L7.48815 10.7222C8.49052 8.94111 9.72038 6.14111 9.72038 4.23556C9.72038 3.18556 9.55687 2.47778 9.30095 1.89444L13.3318 1Z",
			fill: "var(--fill-0, #008CFF)"
		})
	})
});
export default SvgVenmo;
